import { TEXT_PROBLEMS } from '../../../../services/feedback';

// Ошибка сервера с объектом в detail приходит строкой JSON: {"code":"text_rejected","details":["link"]}.
export const errorText = (error) => {
    try {
        const parsed = JSON.parse(error?.message || '');
        const codes = {
            no_text_review: 'На отзыв без текста ответить нельзя',
            already_sent: 'Ответ уже отправлен',
            item_incomplete: 'Не хватает данных обращения для поиска карточки в кабинете',
            account_not_ready: 'У кабинета нет Seller ID или владельца',
            insufficient_balance: 'Недостаточно средств на балансе плательщика для запроса к ИИ',
            not_configured: 'Агент ИИ ещё не подключён на сервере',
            payer_not_set: 'У кабинета не указан плательщик',
            not_enough_reviews: 'Для анализа нужно хотя бы 3 отзыва с текстом за выбранный период',
            bad_response: 'ИИ вернул ответ в непонятном виде, попробуйте ещё раз',
            network: 'Нет связи с ИИ, попробуйте позже',
        };
        if (parsed?.code === 'text_rejected') {
            return `Текст нельзя публиковать: ${(parsed.details || []).map((code) => TEXT_PROBLEMS[code] || code).join('; ')}`;
        }
        if (codes[parsed?.code]) return codes[parsed.code];
    } catch (parseError) {
        // обычное текстовое сообщение
    }
    return error?.message || 'Не удалось выполнить запрос';
};

export function Stars({ rating }) {
    if (!rating) return null;
    return <span className="fb-stars" title={`${rating} из 5`}>{'★'.repeat(rating)}{'☆'.repeat(5 - rating)}</span>;
}

export const money = (value) => `${Number(value || 0).toFixed(2)} ₽`;
